import rest from '@data/restWrapper';
import { CustomerSupportForm } from './helpAndSupport';

export const getInternalDocumentation = async () => {
    const documentation = await rest('/getInternalDocumentation');
    return documentation;
};

export const createTrelloCard = async (newCard: CustomerSupportForm) => {
    const card = await rest('/createTrelloCard', 'POST', newCard);
    return card;
};

export const getUserManualDocumentation = async () => {
    return await rest('/getUserManualDocumentation', 'GET');
};
